import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Flip, toast, Zoom } from "react-toastify";
import { getPurchaseOrdersList, postPurchaseOrders, putPurchaseOrders } from "../api/purchaseOrdersAPI";
import { getVendorsList, postVendors, putVendors } from "../api/vendorsAPI";

export const fetchVendors = createAsyncThunk("po/fetchVendors", async (payload, { rejectWithValue }) => {
  try {
    const response = await getVendorsList(payload);
    // console.log('responseresponse',response)
    return response;
  } catch (error) {
    console.log("Error ", error);
    return rejectWithValue(error.message);
  }
});

export const addVendors = createAsyncThunk("po/addVendors", async (payload, { rejectWithValue }) => {
  try {
    const response = await postVendors(payload);
    // console.log('responseresponse',response)
    return response;
  } catch (error) {
    console.log("Error ", error);
    return rejectWithValue(error.message);
  }
});


export const updateVendor = createAsyncThunk("po/updateVendor", async (payload, { rejectWithValue }) => {
  try {
    const response = await putVendors(payload);
    // console.log('responseresponse',response)
    return response;
  } catch (error) {
    console.log("Error ", error);
    return rejectWithValue(error.message);
  }
});


export const vendorsSlice = createSlice({
  name: "vendors",
  initialState: {
    post: {
      status: null,
      error: null,
      data: null,
    },
    put: {
      status: null,
      error: null,
      data: null,
    },
    get: {
      status: null,
      error: null,
      list: [],
    },
  },

  extraReducers: {
    [fetchVendors.pending]: (state) => {
      state.get.status = "loading";
    },
    [fetchVendors.fulfilled]: (state, {payload}) => {
      const { status, data } = payload;
      if (status === 200) {
        state.get.list = data;
        state.get.error = null;
      }else{
        state.get.error = { message: `${status} - An error occurred` };
        toast.error("System error couldn't get vendors!", {
          autoClose: 1300,
          hideProgressBar: true,
        });
      }
      state.get.status = 'idle';
    },
    [fetchVendors.rejected]: (state, action) => {
      state.get.status = "idle";
      state.get.error = { message: "An error occurred" };
      console.log("***** ERROR PAYLOAD ******* ", action);
      toast.error("System error couldn't get vendors!", {
        autoClose: 1300,
        hideProgressBar: true,
      });
    },
    [addVendors.pending]: (state) => {
      state.post.status = "loading";
    },
    [addVendors.fulfilled]: (state, {payload}) => {
      const { status, data } = payload;
      if (status === 201) {
        toast.success("Vendor saved.", {
          autoClose: 1300,
          transition: Flip,
          hideProgressBar: true,
        });
        state.post.status = "idle";
        state.post.error = null;
      }else{
        toast.warn("Couldn't save vendor!", {
          autoClose: 1300,
          hideProgressBar: true,
        });
        state.post.error = "Failed";
      }

      state.post.data = data;
    },
    [addVendors.rejected]: (state, action) => {
      //state.post.status = "idle";
      state.post.error = { message: "An error occurred" };
      console.log("***** ERROR PAYLOAD ******* ", action);
      toast.error("System error couldn't save vendor!", {
        autoClose: 1300,
        hideProgressBar: true,
      });
    },
    
    [updateVendor.pending]: (state) => {
      state.put.status = "loading";
    },
    [updateVendor.fulfilled]: (state, {payload}) => {
      const { status, data } = payload;
      if (status === 202) {
        toast.success("Vendor saved.", {
          autoClose: 1300,
          transition: Flip,
          hideProgressBar: true,
        });
        state.put.status = "idle";
      }else{
        state.put.error = "Failed";
        toast.warn("Couldn't update vendor!", {
          autoClose: 1300,
          hideProgressBar: true,
        });
      }
      state.put.data = data;
    },
    [updateVendor.rejected]: (state, action) => {
      state.put.status = "idle";
      state.put.error = { message: "An error occurred" };
      console.log("***** ERROR PAYLOAD ******* ", action);
      toast.error("System error couldn't update Vendor!", {
        autoClose: 1300,
        hideProgressBar: true,
      });
    },
  },
});

export default vendorsSlice.reducer;
